module.exports = __webpack_public_path__ + "img/Bolsa Carryall 50.7b534a05.jpg";